import { useEffect } from "react";
import { useStatusSocket } from "../contexts/StatusSocketContext";

export function useEntityStatusSync(entity, onUpdate) {
  const { subscribeStatus } = useStatusSocket();
  useEffect(() => {
    if (!subscribeStatus || !onUpdate) return;
    return subscribeStatus(entity, onUpdate);
  }, [entity, subscribeStatus, onUpdate]);
}
